import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { getSchemeUrl } from "@/utils/toolsApi";
import env from "md-base-tools/env";

// 添加客服

export default {
  setup(__props) {
    const goToKF = () => {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://mini_program?name=gh_7210ac3f1f08&path=pages/index/index?nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/779`,
        webFun: () => {
          if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateTo({
              url: '/pages/webviewPages/content/content?url=https://m.modian.com/ip/webActivity/779'
            });
          } else {
            getWXSchemeUrl();
          }
        }
      });
    };
    const getWXSchemeUrl = async () => {
      const param = {
        path: "/pages/index/index",
        query: `nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/779`
      };
      const option = {
        jump_wxa: JSON.stringify(param)
      };
      const url = await getSchemeUrl(option);
      location.href = url;
    };

    // 页面加载时自动执行
    onMounted(() => {
      goToKF();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "kf-btn",
        onClick: goToKF
      }, "正在跳转至摩点小程序...")]);
    };
  }
};